type BetterDocPayloadError = { readonly message?: string }

export const collectBetterDocErrorMessages = (errors: ReadonlyArray<BetterDocPayloadError> | null | undefined) =>
  (errors ?? []).flatMap((error) => (error.message === undefined ? [] : [error.message]))
